export default __webpack_public_path__ + "media/images/features/yado/link-057ef22357060bb6ab491ccb3d0c8843.png";